import api from '@/utils/api';
import config from '@/config';
import Cookies from 'js-cookie';

const backupLogsService = {
  // Get backup logs list with pagination
  getBackupLogs: async (params = {}) => {
    return api.get(config.endpoints.backupLogs.list, params);
  },

  // Delete backup log by ID
  deleteBackupLog: async (id) => {
    return api.delete(`${config.endpoints.backupLogs.delete}/${id}`);
  },

  // Bulk delete backup logs by IDs
  bulkDeleteBackupLogs: async (ids) => {
    return api.delete(config.endpoints.backupLogs.bulkDelete, {
      params: { ids },
      paramsSerializer: { indexes: null },
    });
  },

  // Download backup file by ID
  // Uses window.location.href instead of blob to avoid loading large files into browser memory.
  // Token is passed as query param because navigation requests don't send Authorization headers.
  downloadBackupLog: (id) => {
    const token = Cookies.get('token');
    const baseUrl = config.api.baseURL.replace(/\/$/, '');
    const url = `${baseUrl}${config.endpoints.backupLogs.download}/${id}/download?token=${encodeURIComponent(token)}`;
    window.location.href = url;
  },
};

export default backupLogsService;
